import React from 'react';

// Character images
const characterImages = {
  // Peeking poses
  peek1: "https://customer-assets.emergentagent.com/job_editorial-fashion-1/artifacts/flvtord6_1.png",
  peek2: "https://customer-assets.emergentagent.com/job_editorial-fashion-1/artifacts/ih96oedh_2.png",
  // Full poses
  full1: "https://customer-assets.emergentagent.com/job_editorial-fashion-1/artifacts/6fh9ak89_a0e30414-6845-4cbe-9aff-b2dced048f11.jpeg",
  full2: "https://customer-assets.emergentagent.com/job_editorial-fashion-1/artifacts/ovvwwbyc_Gemini_Generated_Image_1jlarn1jlarn1jla.png",
  full3: "https://customer-assets.emergentagent.com/job_editorial-fashion-1/artifacts/vbphw7qi_Gemini_Generated_Image_3iaxe93iaxe93iax%20%281%29.png"
};

// Peeking from bottom right
export const CharacterPeekRight = ({ className = "" }) => (
  <div className={`fixed bottom-0 right-8 z-40 pointer-events-none ${className}`}>
    <img 
      src={characterImages.peek1}
      alt="Mariam character"
      className="w-24 md:w-32 lg:w-40 h-auto transform translate-y-4 hover:translate-y-0 transition-transform duration-500"
    />
  </div>
);

// Peeking from bottom left
export const CharacterPeekLeft = ({ className = "" }) => (
  <div className={`fixed bottom-0 left-8 z-40 pointer-events-none ${className}`}>
    <img 
      src={characterImages.peek2}
      alt="Mariam character"
      className="w-24 md:w-32 lg:w-40 h-auto transform translate-y-4 hover:translate-y-0 transition-transform duration-500"
    />
  </div>
);

// Character peeking from a section edge
export const CharacterSectionPeek = ({ position = "right", className = "" }) => (
  <div className={`absolute ${position === "right" ? "-right-4 md:-right-8" : "-left-4 md:-left-8"} bottom-0 z-10 ${className}`}>
    <img 
      src={position === "right" ? characterImages.peek1 : characterImages.peek2}
      alt="Mariam character"
      className="w-20 md:w-28 lg:w-36 h-auto"
    />
  </div>
);

// Character floating next to content
export const CharacterFloat = ({ variant = 1, className = "" }) => {
  const images = [characterImages.full1, characterImages.full2, characterImages.full3];
  return (
    <div className={`${className}`}>
      <img 
        src={images[variant - 1] || images[0]}
        alt="Mariam character"
        className="w-full h-auto rounded-lg"
      />
    </div>
  );
};

// Character avatar for small placements
export const CharacterAvatar = ({ size = "md", className = "" }) => {
  const sizeClasses = {
    sm: "w-12 h-12",
    md: "w-16 h-16",
    lg: "w-24 h-24",
    xl: "w-32 h-32"
  };
  
  return (
    <div className={`${sizeClasses[size]} rounded-full overflow-hidden border-2 border-white/20 ${className}`}>
      <img 
        src={characterImages.full2}
        alt="Mariam character"
        className="w-full h-full object-cover object-top"
      />
    </div>
  );
};

// Animated character that peeks on scroll - using a different image without text
export const CharacterScrollPeek = ({ show = false, className = "" }) => (
  <div 
    className={`fixed bottom-0 right-8 z-40 transition-all duration-700 ${
      show ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
    } ${className}`}
  >
    <img 
      src={characterImages.full2}
      alt="Mariam character"
      className="w-48 md:w-56 lg:w-64 h-auto drop-shadow-2xl"
    />
  </div>
);

export { characterImages };
export default CharacterFloat;
